import {
  getInsuranceFlowLabel,
  InsuranceFlowStatus,
} from 'src/app/enums/insurance-flow/insurance-flow-status.enum';

type TaskDetailsSubStepConfig = {
  id: string;
  label: string;
  status: InsuranceFlowStatus;
  required?: boolean;
};

type TaskDetailsStepConfig = {
  id: string;
  label: string;
  subSteps: TaskDetailsSubStepConfig[];
};

export const TASK_DETAILS_STEP_CONFIG: TaskDetailsStepConfig[] = [
  {
    id: 'lead',
    label: $localize`Lead`,
    subSteps: [
      {
        id: 'lead-pending',
        label: 'Demande de proposition',
        status: InsuranceFlowStatus.PENDING_LEAD,
      },
      {
        id: 'lead-sent-to-insurer',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.LEAD_SENT_TO_INSURER),
        status: InsuranceFlowStatus.LEAD_SENT_TO_INSURER,
      },
      {
        id: 'lead-preparing-offers',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.PREPARING_OFFERS),
        status: InsuranceFlowStatus.PREPARING_OFFERS,
      },
      {
        id: 'lead-cancelled',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.LEAD_CANCELLED),
        status: InsuranceFlowStatus.LEAD_CANCELLED,
        required: false,
      },
      {
        id: 'lead-updated',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.LEAD_UPDATED),
        status: InsuranceFlowStatus.LEAD_UPDATED,
        required: false,
      },
    ],
  },
  {
    id: 'propositions',
    label: $localize`Propositions`,
    subSteps: [
      {
        id: 'proposal-pending-validation',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.PENDING_OFFERS),
        status: InsuranceFlowStatus.PENDING_OFFERS,
      },
      {
        id: 'proposal-signed',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.OFFER_SIGNED),
        status: InsuranceFlowStatus.OFFER_SIGNED,
      },
      {
        id: 'proposal-updated',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.OFFER_UPDATED),
        status: InsuranceFlowStatus.OFFER_UPDATED,
        required: false,
      },
    ],
  },
  {
    id: 'contract-to-submit',
    label: $localize`Contrat à soumettre`,
    subSteps: [
      {
        id: 'contract-pending',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.PENDING_CONTRACT),
        status: InsuranceFlowStatus.PENDING_CONTRACT,
      },
      {
        id: 'contract-updated',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.CONTRACT_UPDATED),
        status: InsuranceFlowStatus.CONTRACT_UPDATED,
        required: false,
      },
    ],
  },
  {
    id: 'contract-submitted',
    label: $localize`Contrat soumis`,
    subSteps: [
      {
        id: 'contract-pending-validation',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.PENDING_VALIDATION),
        status: InsuranceFlowStatus.PENDING_VALIDATION,
      },
      {
        id: 'contract-awaiting-payment',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.AWAITING_PAYMENT),
        status: InsuranceFlowStatus.AWAITING_PAYMENT,
      },
      {
        id: 'contract-cancelled',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.CONTRACT_CANCELLED),
        status: InsuranceFlowStatus.CONTRACT_CANCELLED,
        required: false,
      },
      {
        id: 'contract-refused',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.CONTRACT_REFUSED),
        status: InsuranceFlowStatus.CONTRACT_REFUSED,
        required: false,
      },
    ],
  },
  {
    id: 'policy',
    label: $localize`Police`,
    subSteps: [
      {
        id: 'policy-pending-activation',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.PENDING_ACTIVATION),
        status: InsuranceFlowStatus.PENDING_ACTIVATION,
      },
      {
        id: 'policy-active',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.POLICY_ACTIVE),
        status: InsuranceFlowStatus.POLICY_ACTIVE,
      },
      {
        id: 'policy-suspended',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.POLICY_SUSPENDED),
        status: InsuranceFlowStatus.POLICY_SUSPENDED,
        required: false,
      },
      {
        id: 'policy-cancelled',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.POLICY_CANCELLED),
        status: InsuranceFlowStatus.POLICY_CANCELLED,
        required: false,
      },
      {
        id: 'policy-archived',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.POLICY_ARCHIVED),
        status: InsuranceFlowStatus.POLICY_ARCHIVED,
        required: false,
      },
      {
        id: 'policy-inactive',
        label: getInsuranceFlowLabel(InsuranceFlowStatus.POLICY_INACTIVE),
        status: InsuranceFlowStatus.POLICY_INACTIVE,
        required: false,
      },
    ],
  },
];
